import { render, staticRenderFns } from "./BinsBrowse.vue?vue&type=template&id=4681e9f2&scoped=true"
import script from "./BinsBrowse.vue?vue&type=script&lang=js"
export * from "./BinsBrowse.vue?vue&type=script&lang=js"
import style0 from "./BinsBrowse.vue?vue&type=style&index=0&id=4681e9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681e9f2",
  null
  
)

export default component.exports